@use 'vars';

.streaming-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
}
